"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetObject = void 0;
const lodash_1 = require("lodash");
// vue外传 不然client包 组件推导会出错。。。待解决
function resetObject(ref, value, Vue) {
    const refKeys = Object.keys(ref);
    const valueKeys = Object.keys(value);
    const otherKeys = (0, lodash_1.difference)(refKeys, valueKeys);
    if (Array.isArray(otherKeys)) {
        otherKeys.forEach((key) => {
            Vue.delete(ref, key);
        });
    }
    valueKeys.forEach((key) => {
        Vue.set(ref, key, value[key]);
    });
}
exports.resetObject = resetObject;
//# sourceMappingURL=vue.js.map